import { Box, Divider, Grid, Typography } from '@mui/material'
import React, { useState, useEffect, useCallback } from 'react'
import { COLORS } from '../../constants/colors'
import { addToFavorites, getCartTotalWithStock, getToken, loadCartItems, removeCartItem } from '../../helpers/utilities'
import { BOGPayment, TBCBnpl } from '../../models/payment/PaymentMethod'
import { Title } from '../Typography/Title'
import { bogApplePayPaymentService, bogPaymentService, bogWalletPaymentService, tbcBnplService } from '../../models/payment/service'
import { Animated } from "react-animated-css";
import { Order } from '../../models/order/Order'
import { orderService, tbcInstallmentService } from '../../models/order/service'
import { environment } from '../../environment/environment'
import { BlackButton } from '../Button/BlackButton'
import { cartService } from '../../models/cart/service'
import { ProductCheckoutComponent } from '../Product/ProductCheckoutComponent'
import { ProductCheckoutComponentMobile } from '../Product/ProductCheckoutComponentMobile'
import { Settings } from '../../models/settings/settings'
import { settingsService } from '../../models/settings/service'
import { QueryOptions } from '../../helpers/query.options'
import { analyticsService } from '../../models/analytics/service'
import { CheckoutActionButton } from './checkoutActionButtonStyles'
declare var BOG: any
declare var google: any
declare var ApplePaySession: any

const GOOGLE_PAY_SCRIPT_ID = "google-pay-js"

const loadGooglePayScript = () => new Promise<void>((resolve, reject) => {
    if ((window as any).google?.payments?.api) {
        resolve()
        return
    }
    const existingScript = document.getElementById(GOOGLE_PAY_SCRIPT_ID)
    if (existingScript) {
        existingScript.addEventListener("load", () => resolve())
        existingScript.addEventListener("error", () => reject(new Error("Google Pay SDK failed to load")))
        return
    }
    const script = document.createElement("script")
    script.id = GOOGLE_PAY_SCRIPT_ID
    script.async = true
    script.src = "https://pay.google.com/gp/p/js/pay.js"
    script.onload = () => resolve()
    script.onerror = () => reject(new Error("Google Pay SDK failed to load"))
    document.head.appendChild(script)
})

export const CheckoutFourthStepComponent = (props) => {
    const { 
        app,
        language,
        translations,
        address,
        paymentMethod,
        shippingMethod,
        discountCampaigns,
        campaign,
        auth,
        discount,
        onReloadCampaign,
        onUpdateCart,
        setSnackBar,
        setFavorites,
        setConfirmation,
        setCart,
        coupon,
        loyaltyCard } = props


    const [settings, setSettings] = useState<Settings>()
    const [loaded, setLoaded] = useState(false)
    const [orderLoading, setOrderLoading] = useState(false)
    const [animateShippingError, setAnimateShippingError] = useState(false)
    const [animatePaymentError, setAnimatePaymentError] = useState(false)

    useEffect(() => {

        setLoaded(true)
        analyticsService.beginCheckout(app.cart)
        loadCartItems(setCart, language)
        return () => {
        }
    }, [])

    useEffect(() => {
        settingsService.readWithNoId(new QueryOptions()).then((resp) => {
            setSettings(resp)
        }).catch(() => {

        })
    }, [])


    const openBOGModal = async (amount, orderId, bnpl) => {

        const token = await getToken();
        BOG.Calculator.open({
            bnpl,
            amount,
            onClose: () => {

            },
            onRequest: (selected, successCb, closeCb) => {
                const {
                    amount, month, discount_code
                } = selected;

                fetch(`${environment.basePath}/rest_bog_installment`, {
                    headers: new Headers({
                        "Content-Type": "application/json",
                        'Authorization': `Bearer ${token}`
                    }),
                    method: 'POST',
                    body: JSON.stringify({ ...selected, order_id: orderId })
                })
                    .then(response => response.json())
                    .then(data => successCb(data.order_id))
                    .catch(err => closeCb());
            },
            onComplete: () => {

            }
        })
    }

    const createTBCInstallment = (id) => {
        const order = new Order()
        order.id = id
        tbcInstallmentService.create(order).then((r: any) => {
            console.log(r)
            window.location.href = r.location
        })
    }
    
    const createBOGPayment = (id) => {
        const payment = new BOGPayment()
        payment.id = id
        bogPaymentService.create(payment).then(r => {
            if (r.status === "CREATED") {
                const [link] = r.links.filter(l => l.method === "REDIRECT")
                if (link) {
                    localStorage.setItem("url", link.href)
                    window.location.href = link.href
                }
            }
        })
    }

    const getBogWalletErrorMessage = (payment: any, fallback: string) => {
        const data = payment?.response?.data || payment?.data
        if (typeof data === "string") {
            try {
                const parsed = JSON.parse(data)
                return parsed.error_description || parsed.error || fallback
            } catch (error) {
                return data || fallback
            }
        }
        return payment?.response?.error || payment?.message || fallback
    }

    const completeBogWalletPayment = (payment: any, id: string, fallbackError: string) => {
        if (!payment || payment.ok === false || payment.status >= 400 || payment.response?.ok === false) {
            setSnackBar({ ...app.snackBar, open: true, text: getBogWalletErrorMessage(payment, fallbackError), bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
            return
        }
        if (payment.status === "completed") {
            window.location.href = "/payment_callback?order_id=" + id
            return
        }
        const redirectLink = payment.links?.find(l => l.method === "REDIRECT")
        if (redirectLink) {
            localStorage.setItem("url", redirectLink.href)
            window.location.href = redirectLink.href
            return
        }
        setSnackBar({ ...app.snackBar, open: true, text: fallbackError, bColor: 'rgb(234, 51, 35)' })
        setOrderLoading(false)
    }

    const createBOGGooglePayPayment = async (order: Order) => {
        try {
            await loadGooglePayScript()
            const paymentsClient = new google.payments.api.PaymentsClient({
                environment: environment.googlePayEnvironment
            })
            const baseCardPaymentMethod = {
                type: "CARD",
                parameters: {
                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                    allowedCardNetworks: ["VISA", "MASTERCARD"]
                }
            }
            const tokenizedCardPaymentMethod = {
                ...baseCardPaymentMethod,
                tokenizationSpecification: {
                    type: "PAYMENT_GATEWAY",
                    parameters: {
                        gateway: environment.googlePayGateway,
                        gatewayMerchantId: environment.googlePayGatewayMerchantId
                    }
                }
            }
            const isReady = await paymentsClient.isReadyToPay({
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [baseCardPaymentMethod]
            })
            if (!isReady.result) {
                setSnackBar({ ...app.snackBar, open: true, text: "Google Pay is not available.", bColor: 'rgb(234, 51, 35)' })
                setOrderLoading(false)
                return
            }
            const paymentData = await paymentsClient.loadPaymentData({
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [tokenizedCardPaymentMethod],
                merchantInfo: {
                    merchantName: environment.googlePayMerchantName
                },
                transactionInfo: {
                    totalPriceStatus: "FINAL",
                    totalPrice: Number(order.totalToPay).toFixed(2),
                    currencyCode: "GEL",
                    countryCode: "GE"
                }
            })
            const payment = new BOGPayment()
            payment.id = order.id
            payment.paymentMethod = "google_pay"
            payment.googlePayToken = paymentData?.paymentMethodData?.tokenizationData?.token
            if (!payment.googlePayToken) {
                setSnackBar({ ...app.snackBar, open: true, text: "Google Pay token was not returned.", bColor: 'rgb(234, 51, 35)' })
                setOrderLoading(false)
                return
            }
            bogWalletPaymentService.create(payment).then((r: BOGPayment) => {
                completeBogWalletPayment(r, order.id, "Google Pay failed.")
            })
        } catch (error: any) {
            setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Google Pay failed.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
        }
    }

    const createBOGApplePayPayment = async (order: Order) => {
        try {
            const payment = new BOGPayment()
            payment.id = order.id
            payment.paymentMethod = "apple_pay"
            const created = await bogWalletPaymentService.create(payment) as BOGPayment
            completeBogWalletPayment(created, order.id, "Apple Pay failed.")
        } catch (error: any) {
            setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Apple Pay failed.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
        }
    }

    const buildOrder = () => {
        const order = new Order()
        order.lang = language
        order.address = address
        order.shippingMethod = shippingMethod
        order.paymentMethod = paymentMethod
        if (coupon?.name) {
            order.coupon = coupon.name
        }
        if (loyaltyCard) {
            order.loyaltyCard = loyaltyCard.id;
        }
        return order
    }

    const createApplePayRequest = () => ({
        countryCode: "GE",
        currencyCode: "GEL",
        merchantCapabilities: ["supports3DS"],
        supportedNetworks: ["visa", "masterCard"],
        total: {
            label: "Voulez Vous",
            amount: Math.max(0, Number(getCartTotalWithStock(app.cart) + getShippingPrice(shippingMethod, settings, app.cart, coupon) - discount - campaign)).toFixed(2)
        }
    })

    const createApplePaySession = () => {
        if (!(window as any).ApplePaySession) {
            setSnackBar({ ...app.snackBar, open: true, text: "Apple Pay is not available.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
            return
        }
        if (ApplePaySession.canMakePayments && !ApplePaySession.canMakePayments()) {
            setSnackBar({ ...app.snackBar, open: true, text: "Apple Pay is not set up on this device.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
            return
        }

        let cartOrder: Order | null = null
        let bogOrder: any = null
        let session
        try {
            session = new ApplePaySession(3, createApplePayRequest())
        } catch (error: any) {
            setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Apple Pay could not start.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
            return
        }

        session.onvalidatemerchant = async () => {
            try {
                const order = buildOrder()
                analyticsService.addShippingInfo(shippingMethod, app.cart)
                analyticsService.addPaymentInfo(paymentMethod, app.cart)
                cartOrder = await orderService.create(order) as Order
                analyticsService.purchase(cartOrder, app.cart)

                const payment = new BOGPayment()
                payment.id = cartOrder.id
                payment.paymentMethod = "apple_pay"
                bogOrder = await bogWalletPaymentService.create(payment) as any

                if (!bogOrder || bogOrder.ok === false || bogOrder.status >= 400 || bogOrder.response?.ok === false) {
                    session.abort()
                    setSnackBar({ ...app.snackBar, open: true, text: getBogWalletErrorMessage(bogOrder, "Apple Pay failed."), bColor: 'rgb(234, 51, 35)' })
                    setOrderLoading(false)
                    return
                }
                const merchantSession = bogOrder.result?.model || bogOrder.result
                if (!merchantSession?.merchantIdentifier) {
                    session.abort()
                    setSnackBar({ ...app.snackBar, open: true, text: "Apple Pay merchant validation failed.", bColor: 'rgb(234, 51, 35)' })
                    setOrderLoading(false)
                    return
                }
                session.completeMerchantValidation(merchantSession)
            } catch (error: any) {
                session.abort()
                setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Apple Pay failed.", bColor: 'rgb(234, 51, 35)' })
                setOrderLoading(false)
            }
        }

        session.onpaymentauthorized = async (event) => {
            try {
                const payment = new BOGPayment()
                payment.orderId = bogOrder?.orderId
                payment.applePayToken = JSON.stringify(event.payment)
                const completed = await bogApplePayPaymentService.create(payment) as any
                if (!completed || completed.ok === false || completed.status >= 400 || completed.response?.ok === false) {
                    session.completePayment(ApplePaySession.STATUS_FAILURE)
                    setSnackBar({ ...app.snackBar, open: true, text: getBogWalletErrorMessage(completed, "Apple Pay failed."), bColor: 'rgb(234, 51, 35)' })
                    setOrderLoading(false)
                    return
                }
                session.completePayment(ApplePaySession.STATUS_SUCCESS)
                window.location.href = "/payment_callback?order_id=" + cartOrder?.id
            } catch (error: any) {
                session.completePayment(ApplePaySession.STATUS_FAILURE)
                setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Apple Pay failed.", bColor: 'rgb(234, 51, 35)' })
                setOrderLoading(false)
            }
        }

        session.oncancel = () => {
            setSnackBar({ ...app.snackBar, open: true, text: "Apple Pay was cancelled or is not available for this domain.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
        }

        try {
            session.begin()
        } catch (error: any) {
            setSnackBar({ ...app.snackBar, open: true, text: error?.message || "Apple Pay could not start.", bColor: 'rgb(234, 51, 35)' })
            setOrderLoading(false)
        }
    }
    const createTBCBnplPayment = (id) => {
        const payment = new TBCBnpl()
        payment.orderId = id
        tbcBnplService.create(payment).then(r => {
            if (r.url) {
                localStorage.setItem("url", r.url)
                window.location.href = r.url
            }
        })
    }

    const onRemoveItem = (confirmation) => {
        if (auth.loggedIn) {
            cartService.delete(confirmation.item.sku).then(() => {
                loadCartItems(setCart, language)
                setConfirmation({ ...confirmation, open: false })
                onReloadCampaign()
                setSnackBar({ ...app.snackBar, open: true, text: `${confirmation.item.product.name} ${translations?.has_been_deleted}`, bColor: "rgb(83, 148, 96)" })
            })
        } else {

            removeCartItem(confirmation.item.sku, app, setCart)
            setConfirmation({ ...confirmation, open: false })
            onReloadCampaign()
            setSnackBar({ ...app.snackBar, open: true, text: `${confirmation.item.product.name} ${translations?.has_been_deleted}`, bColor: "rgb(83, 148, 96)" })
        }
    }

    const onMoveToFavorites = (confirmation) => {
        addToFavorites(confirmation.item.product, confirmation.item.sku, app, auth).then(r => {
            setSnackBar({ ...app.snackBar, open: true, text: `${confirmation.item.product.name} ${translations.has_been_added_to_favs}.`, bColor: "rgb(83, 148, 96)" })
            setFavorites(r)
            if (auth.loggedIn) {
                cartService.delete(confirmation.item.sku).then(() => {
                    loadCartItems(setCart, language)
                    setConfirmation({ ...confirmation, open: false })
                    onReloadCampaign()
                })
            } else {
                removeCartItem(confirmation.item.sku, app, setCart)
                setConfirmation({ ...confirmation, open: false })
                onReloadCampaign()
            }
        })
    }


    const registerOrder = () => {
        if (orderLoading) {
            return
        }
        if (!shippingMethod) {
            setAnimateShippingError(true)
            setTimeout(() => {
                setAnimateShippingError(false)
            }, 5000)
            return
        }
        if (!paymentMethod) {
            setAnimatePaymentError(true)
            setTimeout(() => {
                setAnimatePaymentError(false)
            }, 5000)
            return
        }
        setOrderLoading(true)
        if (paymentMethod.uid === "apple_pay_bog") {
            createApplePaySession()
            return
        }
        const order = buildOrder()
        analyticsService.addShippingInfo(shippingMethod, app.cart)
        analyticsService.addPaymentInfo(paymentMethod, app.cart)
        orderService.create(order).then(r => {
            analyticsService.purchase(r, app.cart)
            if (r.paymentMethod.uid === "installment_bog") {
                openBOGModal(r.totalToPay, r.id, false)
            }
            if (r.paymentMethod.uid === "by_parts_bog") {
                openBOGModal(r.totalToPay, r.id, true)
            }
            if (r.paymentMethod.uid === "gift_card") {
                if (r.splitGiftCardPayment) {
                    setTimeout(() => {
                        createBOGPayment(r.id)
                    }, 40)
                } else {
                    window.location.href = "/payment_callback?order_id=" + r.id
                }
            }
            if (r.paymentMethod.uid === "card_bog") {
                setTimeout(() => {
                    createBOGPayment(r.id)
                }, 40)
            }
            if (r.paymentMethod.uid === "google_pay_bog") {
                createBOGGooglePayPayment(r)
            }
            if (r.paymentMethod.uid === "apple_pay_bog") {
                createBOGApplePayPayment(r)
            }
            if (r.paymentMethod.uid === "installment_tbc") {
                createTBCInstallment(r.id)
            }
            if (r.paymentMethod.uid === "tbc_bnpl") {
                createTBCBnplPayment(r.id)
            }
        }).catch(() => {
            setOrderLoading(false)
        })
    }

    const getShippingPrice = (shippingMethod, settings, cartItems, coupon) => {
        var cost = 0;
        if (shippingMethod) {
            cost = shippingMethod.price;
        }
        const total = getCartTotalWithStock(cartItems)

        if (settings && settings.freeShippingMin) {
            if (total >= Number(settings.freeShippingMin)) {
                cost = 0
            }
        }
        if (coupon?.campaign?.freeShipping) {
            cost = 0;
        }
        return cost
    }

    const RenderTotal = useCallback(() => {
        return <Typography component="h4" variant="subtitle2" style={{ fontWeight: '500', fontSize: 17, }}>
            {Number(0 + getCartTotalWithStock(app.cart)).toFixed(2)} ₾
        </Typography>
    }, [app.cart, shippingMethod])

    const RenderDiscount = useCallback(() => {
        return <Typography component="h4" variant="subtitle2" style={{ fontWeight: '500', fontSize: 17, }}>
            {discount.toFixed(2)} ₾
        </Typography>
    }, [discount])

    const RenderCampaignDiscount = useCallback(() => {
        return <Typography component="h4" variant="subtitle2" style={{ fontWeight: 'bold', fontSize: 17, }}>
            {campaign.toFixed(2)} ₾
        </Typography>
    }, [campaign])

    const RenderShippingCost = useCallback(() => {
        var cost = shippingMethod.price
        if (settings && settings.freeShippingMin) {

            if (getCartTotalWithStock(app.cart) > Number(settings.freeShippingMin)) {
                cost = 0;
            }
        }
        if (coupon?.campaign?.freeShipping) {
            cost = 0;
        }
        return <Typography component="h4" variant="subtitle2" style={{ fontWeight: 'bold', fontSize: 17, }}>
            {cost.toFixed(2)} ₾
        </Typography>
    }, [shippingMethod, app.cart, settings, coupon])

    const RenderYouPay = useCallback(() => {
        return <Typography component="h4" variant="subtitle2" style={{ fontWeight: 'bold', fontSize: 17, }}>
            {Math.max(0, Number(getCartTotalWithStock(app.cart) + getShippingPrice(shippingMethod, settings, app.cart, coupon) - discount - campaign)).toFixed(2)} ₾
        </Typography>
    }, [discount, shippingMethod, settings, coupon, campaign])

    const getDiscountCampaign = (item) => {
        const [campaign] = discountCampaigns.filter((r) => r.sku == item.sku)
        return campaign;
    }

    const isMobile = window.innerWidth < 1200

    return <Animated animationIn="slideInLeft" animationOut="fadeOutRight"
        animationInDuration={500}
        isVisible={loaded} >
        {/* {shippingMethod} */}
        <Grid container style={{ padding: window.innerWidth > 1200 ? 30 : 10 }}>
            <Grid item lg={9} sm={12}>
                {loaded && app?.cart?.sort((n1, n2) => { if (n1.created > n2.created) { return -1; } if (n1.created < n2.created) { return 1; } return 0; }).map((item, index) => {
                    return item.loaded ? <Box key={index} sx={{
                        width: '100%',
                        borderRadius: 2,
                        marginTop: 2,
                        boxShadow: '0px 0px 4px rgba(0,0,0,.5)',
                    }}>
                        {window.innerWidth > 1200 ? <ProductCheckoutComponent
                            showQtyChange={true}
                            onUpdateCart={onUpdateCart}
                            item={item}
                            discountCampaign={getDiscountCampaign(item)}
                            onMessage={(qty) => {
                                setSnackBar({ ...app.snackBar, open: true, text: `${translations.only_available} ${qty} ${translations.items}`, bColor: "rgb(83, 148, 96)" })
                            }}
                            translations={translations}
                            redirect={() => { }}
                            onRemove={(item) => {
                                setConfirmation({
                                    open: true,
                                    item,
                                    type: 'removeItemFromCart',
                                    textAccept: `${translations?.delete}`,
                                    text: `${translations?.do_you_really_want_to_delete_from_cart}`,
                                    title: item.product.name,
                                    onAgreed: onRemoveItem
                                })
                            }}
                            onMoveToFavorites={(item) => {
                                setConfirmation({
                                    open: true,
                                    item,
                                    type: 'removeItemFromCart',
                                    textAccept: `${translations?.move}`,
                                    text: `${translations?.do_you_want_to_move_to_favorites}`,
                                    title: item.product.name,
                                    onAgreed: onMoveToFavorites
                                })
                            }}
                            key={index} /> :
                            <ProductCheckoutComponentMobile
                                {...props}
                                discountCampaign={getDiscountCampaign(item)}
                                language={language}
                                onUpdateCart={onUpdateCart}
                                item={item}
                                translations={translations}
                                redirect={() => { }}
                                onRemove={(item) => {
                                    setConfirmation({
                                        open: true,
                                        item,
                                        type: 'removeItemFromCart',
                                        textAccept: `${translations?.delete}`,
                                        text: `${translations?.do_you_really_want_to_delete_from_cart}`,
                                        title: item.product.name,
                                        onAgreed: onRemoveItem
                                    })
                                }}
                                onMoveToFavorites={(item) => {
                                    setConfirmation({
                                        open: true,
                                        item,
                                        type: 'removeItemFromCart',
                                        textAccept: `${translations?.move}`,
                                        text: `${translations?.do_you_want_to_move_to_favorites}`,
                                        title: item.product.name,
                                        onAgreed: onMoveToFavorites
                                    })
                                }}
                                key={index} />
                        }
                    </Box> : <></>
                })}
            </Grid>

            <Grid item lg={3} xs={12} style={{ padding: 10, paddingTop: 0, paddingBottom: 80, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Box sx={{

                    width: window.innerWidth > 1200 ? '100%' : '90%',
                    borderRadius: 2,
                    flex: 1,
                    marginTop: 2,
                    paddingTop: 1.2,
                    boxShadow: '0px 0px 4px rgba(0,0,0,.5)',
                }}>
                    <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', paddingLeft: 15 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'flex-start', display: 'flex', alignItems: 'flex-start' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: 'bold', fontSize: 17 }}>
                                {translations?.address}
                            </Typography>
                        </div>
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <div style={{ flexDirection: 'column', alignItems: 'flex-start', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <Typography
                                sx={{ textAlign: 'left' }}
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{
                                    fontWeight: '400', fontSize: 16,
                                    textTransform: 'uppercase'
                                }}>
                                {address.street}, {address.city.name}
                            </Typography>
                        </div>
                    </div>
                    <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex' }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'flex-start', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '400', fontSize: 16 }}>
                                {address.phone}
                            </Typography>
                        </div>
                    </div>
                    <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex' }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'flex-start', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '400', fontSize: 16 }}>
                                {address.firstName} {address.lastName}
                            </Typography>
                        </div>
                    </div>
                    <Divider component="div" flexItem sx={{ marginBottom: 1 }} />
                    <div style={{
                        marginTop: 10,
                        flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, paddingRight: 15, paddingBottom: 8
                    }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 17 }}>
                                {translations?.sum}
                            </Typography>
                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <RenderTotal />
                        </div>
                    </div>
                    {discount > 0 && <> <Divider component="div" flexItem sx={{ marginBottom: 1 }} /><div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 17 }}>
                                {translations?.discount}
                            </Typography>
                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <RenderDiscount />
                        </div>
                    </div></>}
                    {campaign > 0 && !discount && <> <Divider component="div" flexItem sx={{ marginBottom: 1 }} /><div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 17 }}>
                                {translations?.discount}
                            </Typography>
                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <RenderCampaignDiscount />
                        </div>

                    </div></>}
                    {campaign > 0 && !discount && <><div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 20, paddingRight: 20, paddingBottom: 8 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{
                                    fontWeight: '500',
                                    fontSize: 14,
                                    textAlign: 'initial'
                                }}>
                                {translations?.campaign_discount}
                            </Typography>
                        </div>
                    </div><Divider component="div" flexItem sx={{ marginBottom: 1 }} /></>}
                    {loyaltyCard?.discount > 0 && <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, paddingBottom: 8 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '600', fontSize: 14, textAlign: 'initial' }}>
                                {translations?.loyalty_card_discount}
                            </Typography>
                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                            <Typography component="h4" variant="subtitle2" style={{ fontWeight: '500', fontSize: 17, }}>
                                {`${loyaltyCard.discount}%`}
                            </Typography>
                        </div>
                    </div>}
                    {coupon?.name && <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, paddingRight: 20, paddingBottom: 7 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '600', fontSize: 14, textAlign: 'initial' }}>
                                {translations?.coupon_discount}
                            </Typography>

                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography component="h4" variant="subtitle2" style={{ fontWeight: 'bold', fontSize: 14 }}>
                                {coupon.campaign.type == "absolute" ?
                                    ` -${coupon.campaign.value}₾`
                                    :
                                    `-${coupon.campaign.value}%`}
                            </Typography>
                        </div>
                    </div>}


                    {shippingMethod && <><Divider component="div" flexItem sx={{ marginBottom: 1 }} /><div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 17 }}>
                                {translations?.shipping_cost}
                            </Typography>

                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <RenderShippingCost />
                        </div>
                    </div></>}

                    <div style={{ flexDirection: 'row', justifyContent: 'flex-start', display: 'flex', marginTop: 0, padding: 15, paddingTop: 5 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '600', fontSize: 14 }}>
                                {shippingMethod?.name} {shippingMethod?.description}
                            </Typography>
                        </div>
                    </div>
                    <Divider component="div" flexItem sx={{ marginBottom: 1 }} />
                    {shippingMethod && <div style={{ flexDirection: 'row', justifyContent: 'center', display: 'flex', paddingLeft: 15, paddingRight: 15 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 17 }}>
                                {translations?.payment}
                            </Typography>

                        </div>

                    </div>}

                    <div style={{ flexDirection: 'row', justifyContent: 'center', display: 'flex', marginTop: 0, padding: 15, paddingTop: 5 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '600', fontSize: 14 }}>
                                {paymentMethod.name}
                            </Typography>
                        </div>
                    </div>
                    <Divider component="div" flexItem sx={{ marginBottom: 1 }} />
                    <div style={{ flexDirection: 'row', justifyContent: 'space-around', display: 'flex', marginTop: 20, padding: 20, paddingBottom: 5, paddingTop: 5 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: '500', fontSize: 15 }}>
                                {translations?.you_have_items_in_your_cart ? translations?.you_have_items_in_your_cart.replace("%s", app.cart?.length) : ''}
                            </Typography>
                        </div>

                    </div>
                    {/* <Divider component="div" flexItem sx={{ marginBottom: 1 }} /> */}
                    <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex', paddingLeft: 15, paddingRight: 15, paddingBottom: 20 }}>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <Typography
                                component="h4"
                                variant="subtitle2"
                                className={'uppercase'}
                                style={{ fontWeight: 'bold', fontSize: 17, textTransform: 'uppercase' }}>
                                {translations?.you_pay}
                            </Typography>

                        </div>
                        <div style={{ flexDirection: 'column', justifyContent: 'center', display: 'flex' }}>
                            <RenderYouPay />
                        </div>
                    </div>
                </Box>
                <CheckoutActionButton isMobile={isMobile}>
                    <BlackButton
                        title={translations.complete_order}
                        color={COLORS.GREEN}
                        loading={orderLoading}
                        onClick={() => {
                            registerOrder()
                        }}
                    />

                </CheckoutActionButton>
                {animateShippingError && <Title
                    uppercase={true}
                    fontFamily={language === 'geo' ? 'FiraGo' : 'Roboto'}
                    color={COLORS.RED}
                    fontSize={14}
                    fontWeight={'400'}
                    text={`${translations?.shipping} ${translations?.is_required}`} />}
                {animatePaymentError && <Title
                    uppercase={true}
                    fontFamily={language === 'geo' ? 'FiraGo' : 'Roboto'}
                    color={COLORS.RED}
                    fontSize={14}
                    fontWeight={'400'}
                    text={`${translations?.payment} ${translations?.is_required}`} />}
            </Grid>
        </Grid >
    </Animated>
}
